'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { LAYOUT_DND_UPDATE_CONTEXT_MONITOR } from 'DesignData/actions/ActionTypes';
/**
 * Current monitor values from the Layout Editors DragDropContext
 */

function monitor(state = SeamlessImmutable({
  isDragging: false,
  itemType: null,
  item: null
}), action) {
  switch (action.type) {
    case LAYOUT_DND_UPDATE_CONTEXT_MONITOR:
      {
        const {
          isDragging,
          itemType,
          item
        } = action;
        return {
          isDragging,
          itemType,
          item
        };
      }

    default:
      return state;
  }
}

export default combineReducers({
  monitor
});